import React, { useRef, useState, useEffect } from "react";

const TabHeader = ({ tabs, activeTab, onTabChange }) => {
  const containerRef = useRef(null);
  const hasMovedRef = useRef(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    hasMovedRef.current = false;
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
    containerRef.current.style.cursor = 'grabbing';
    containerRef.current.style.userSelect = 'none';
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    hasMovedRef.current = false;
    if (containerRef.current) {
      containerRef.current.style.cursor = 'grab';
      containerRef.current.style.userSelect = '';
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    const wasDragging = hasMovedRef.current;
    hasMovedRef.current = false;
    if (containerRef.current) {
      containerRef.current.style.cursor = 'grab';
      containerRef.current.style.userSelect = '';
    }
    return wasDragging;
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    
    if (Math.abs(walk) > 5) {
      hasMovedRef.current = true;
    }
    
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.style.cursor = 'grab';
    }
  }, []);

  return (
    <div 
      className="tab-header-container"
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      <div className="tab-header-scroll">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const isImageIcon = typeof tab.icon === 'string';
          
          return (
            <button
              key={tab.id}
              className={`tab-header-item ${isActive ? 'active' : ''}`}
              onClick={(e) => {
                // Prevent click if we were dragging
                if (hasMovedRef.current) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                onTabChange(tab.id);
              }}
            >
              {isImageIcon ? (
                <img 
                  src={tab.icon} 
                  alt={tab.label}
                  className="tab-header-icon"
                />
              ) : (
                <tab.icon className="tab-header-icon" />
              )}
              <span className="tab-header-label">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabHeader;

